// @flow
import type { CampaignResponse } from '../../sharedTypes';

export const CAMPAIGN = {
  REQUEST_ALL_DATA: 'campaign/request_all_data',
  REQUEST_BOOST_DATA: 'campaign/request_boost_data',
  REQUEST_BOOSTS_DATA: 'campaign/request_boosts_data',
  REQUEST_CHECKOUT_DATA: 'campaign/request_checkout_data',
  RECEIVE_CAMPAIGN: 'campaign/receive_campaign',
  RECEIVE_CAMPAIGN_ERROR: 'campaign/receive_campaign_error',
};

export type RequestAllDataAction = {
  type: typeof CAMPAIGN.REQUEST_ALL_DATA,
  userRole: string | null,
};

export type RequestBoostDataAction = {
  type: typeof CAMPAIGN.REQUEST_BOOST_DATA,
};

export type RequestBoostsDataAction = {
  type: typeof CAMPAIGN.REQUEST_BOOSTS_DATA,
};

export type ReceiveCampaignAction = {
  type: typeof CAMPAIGN.RECEIVE_CAMPAIGN,
  payload: CampaignResponse,
};

export type ReceiveCampaignErrorAction = {
  type: typeof CAMPAIGN.RECEIVE_CAMPAIGN_ERROR,
};

export function requestAllData(
  userRole: string | null,
  flags: {
    socialEcomm: boolean,
    disableAvatars: boolean,
    disableTeamCartsAndAvatars: boolean,
  }
): RequestAllDataAction {
  return {
    userRole,
    flags,
    type: CAMPAIGN.REQUEST_ALL_DATA,
  };
}

export function requestBoostData(): RequestBoostDataAction {
  return {
    type: CAMPAIGN.REQUEST_BOOST_DATA,
  };
}

export function requestBoostsData(payload): RequestBoostsDataAction {
  return {
    type: CAMPAIGN.REQUEST_BOOSTS_DATA,
    payload,
  };
}

export function receiveCampaign(
  payload: CampaignResponse
): ReceiveCampaignAction {
  return {
    type: CAMPAIGN.RECEIVE_CAMPAIGN,
    payload,
  };
}

export function receiveCampaignError(): ReceiveCampaignErrorAction {
  return {
    type: CAMPAIGN.RECEIVE_CAMPAIGN_ERROR,
  };
}
